import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M11.3333 22.6667C5.08 22.6667 0 17.5867 0 11.3333C0 5.08 5.08 0 11.3333 0C17.5867 0 22.6667 5.08 22.6667 11.3333C22.6667 17.5867 17.5867 22.6667 11.3333 22.6667ZM11.3333 1.33333C5.81333 1.33333 1.33333 5.81333 1.33333 11.3333C1.33333 16.8533 5.81333 21.3333 11.3333 21.3333C16.8533 21.3333 21.3333 16.8533 21.3333 11.3333C21.3333 5.81333 16.8533 1.33333 11.3333 1.33333Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M31.3343 32.0001C31.1609 32.0001 30.9876 31.9334 30.8676 31.8001L18.4009 19.3468C18.1476 19.0934 18.1476 18.6668 18.4009 18.4001C18.6543 18.1334 19.0809 18.1468 19.3476 18.4001L31.8009 30.8534C32.0543 31.1068 32.0543 31.5334 31.8009 31.8001C31.6676 31.9334 31.4943 32.0001 31.3343 32.0001Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }